// Widths Next's image optimizer accepts by default (imageSizes + deviceSizes)
const NEXT_WIDTHS = [16, 32, 48, 64, 96, 128, 256, 384, 640, 750, 828, 1080, 1200, 1920, 2048, 3840]

/**
 * A resized image URL for plain <img> tags.
 * - Rehosted images (media.elevatewholesale.com.au) go through Next's image optimizer (resized, WebP/AVIF, cached).
 * - Shopify CDN URLs (cdn.shopify.com or /cdn/shop/) use Shopify's ?width= resizing.
 * - Anything else passes through.
 */
export const shopifyImg = (url: string | undefined | null, width: number) => {
  if (!url) return undefined
  if (url.startsWith("https://media.elevatewholesale.com.au/")) {
    const w = NEXT_WIDTHS.find((x) => x >= width) ?? 3840
    return `/_next/image?url=${encodeURIComponent(url)}&w=${w}&q=75`
  }
  if (!/cdn\.shopify\.com|\/cdn\/shop\//.test(url)) return url
  const base = url.replace(/([?&])width=\d+/, "$1").replace(/[?&]+$/, "").replace("?&", "?")
  return base + (base.includes("?") ? "&" : "?") + "width=" + width
}
